import { FC, useContext } from "react";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import Confirmation from "../../component/Authorization/Confirmation/Confirmation";
import RecoverPasswordForm from "../../component/Authorization/RecoverPassword/RecoverPasswordForm";

const RecoverPassword: FC = () => {
    const { store } = useContext(Context);
    const navigate = useNavigate();

    if (!store.isAuth) {
        return (
            <div>
                <RecoverPasswordForm />
            </div>
        );
    } else if (!store.isActivate) {
        return (
            <div>
                <Confirmation />
            </div>
        );
    } else {
        navigate("/projects");
        return null;
    }
};

export default observer(RecoverPassword);
